export default {
  "site-structure": () => import("/app/frontend-shared/layouts/site-structure.vue").then(m => m.default || m)
}